import React, { useState, useEffect } from "react";
import { Divider } from "semantic-ui-react";
import { Formik } from "formik";
import {
  Paper,
  Grid,
  TextField,
  FormControl,
  Button,
  Switch,
  IconButton,
  TableCell,
  TableRow,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MultipleAutocomplete from "../common/multipleAutocomplete/MultipleAutocomplete";
import Alert from "@material-ui/lab/Alert";
import api from "../../api";
import utils from "../../utils/utils";
import Info from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import { productTypeList, ProductTypesEnum, StatusEnum } from "../../enums/enums";
import { PaymentMethodTypes, PaymentsMethodAssign } from "../../enums/enums";
import { useNavigate, useParams } from "react-router-dom";
import { Add, Delete as DeleteIcon } from "@material-ui/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const CustomInputText = ({ Name, Label, Change, Blur, Value, Error, Type, InputProps, disabled }) => (
  <FormControl fullWidth={true}>
    <TextField
      size="small"
      variant="outlined"
      name={Name}
      label={Label}
      onChange={Change}
      onBlur={Blur}
      type={Type ?? "text"}
      value={Value}
      error={Error}
      InputProps={InputProps}
      required
      disabled={disabled}
    />
  </FormControl>
);

export default function ProductEdit({ setIsLoading, setDataToast }) {
  const { id } = useParams();
  let navigate = useNavigate();
  const [hasServices, setHasServices] = useState(false);
  const [companyData, setCompanyData] = useState();
  const [categoryData, setCategoryData] = useState();
  const [paymentMethodData, setPaymentMethodData] = useState();
  const [typesAssistsData, setTypesAssistsData] = useState();
  const [vehicleTypeList, setVehicleTypes] = useState([]);
  const [termsAndConditions, setTermsAndConditions] = useState();
  const [disabledCompanies, setDisabledCompanies] = useState(true);
  const [vinculatedAgreements, setVinculatedAgreements] = useState(false);
  const [allowPaymentMethod, setAllowPaymentMethod] = useState(false);
  const [openNewFeature, setOpenNewFeature] = React.useState(false);
  const handleOpen = () => setOpenNewFeature(true);
  const handleClose = () => setOpenNewFeature(false);

  //lists
  const [companiesList, setCompaniesList] = useState([]);
  const [typesAssistsList, setTypesAssistsList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [paymentMethodList, setPaymenthMethodList] = useState([]);

  const [defaultValues, setDefaultValues] = useState({
    id: undefined,
    services: "",
    features: [],
    vehicleTypes: [],
    name: "",
    description: "",
    period: "",
    price: "",
    costCenter: "",
    pathPdf: "",
    allowBuyBack: false,
    externalProduct: "",
    productType: null,
    allowPaymentMethod: false,
    paymentMethodId: "",
  });

  const handleDragEnd = (e, setFieldValue, data) => {
    if (!e.destination) return;
    let tempData = Array.from(data);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setFieldValue("features", tempData);
  };

  const shortError = (message) => {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  };

  function save(e, setSubmitting) {
    setIsLoading(true);
    setSubmitting(true);
    if (e.productType?.key === ProductTypesEnum.Vehicular.Id && !e.vehicleTypes?.length) {
      setIsLoading(false);
      setSubmitting(false);
      shortError("Debe seleccionar al menos un tipo de vehículo.");
      return;
    }

    if (validate()) {
      let services = [];
      typesAssistsData.forEach((item) => {
        services.push(item.value);
      });
      let product;

      let caracteristicas = e.features.map((i, order) => ({
        nombre: i.name,
        orden: order + 1,
      }));
      product = {
        servicios: services,
        caracteristicas,
        nombre: e.name,
        descripcion: e.description,
        periodo: e.period,
        rutaPdf: termsAndConditions,
        companiaId: companyData.value,
        precio: e.price,
        centroCosto: e.costCenter,
        categoriaId: categoryData?.value,
        tipoProductoId: e.productType?.key,
        tiposVehiculos:
          e.productType?.key === ProductTypesEnum.Vehicular.Id ? (e.vehicleTypes || []).map(({ value }) => value) : [],
        permitirRecompra: e.allowBuyBack,
        productoExterno: e.externalProduct,
        medioPagoId: paymentMethodData?.value,
      };

      let editServices = arrayEquals(product.servicios, defaultValues.services);
      let editFeatures = arrayEquals(product.caracteristicas || [], defaultValues.features || []);
      let editVehicleTypes = arrayEquals(product.tiposVehiculos || [], defaultValues.tiposVehiculos || []);
      if (
        (defaultValues.pathPdf !== termsAndConditions || defaultValues.price !== product.precio) &&
        defaultValues.category === product.categoriaId &&
        defaultValues.companyId === product.companiaId &&
        defaultValues.productType === product.tipoProductoId &&
        defaultValues.costCenter === product.centroCosto &&
        defaultValues.description === product.descripcion &&
        defaultValues.name === product.nombre &&
        defaultValues.period === product.periodo &&
        defaultValues.allowBuyBack === product.permitirRecompra &&
        defaultValues.externalProduct === product.productoExterno &&
        editServices === true &&
        editFeatures === true &&
        editVehicleTypes === true
      ) {
        let body = {
          rutaPdf: termsAndConditions,
          precio: product.precio,
          fechaPrecio: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        };
        api
          .editProductPdfOrPrice(defaultValues.id, body)
          .then(() => {
            setIsLoading(false);
            setDataToast({
              active: true,
              message: "Producto editado correctamente.",
              type: "success",
            });
            navigate("/producto");
          })
          .catch((err) => {
            setIsLoading(false);
            setSubmitting(false);

            if (err.response.data.errores !== undefined) {
              if (Array.isArray(err.response.data.errores)) {
                err.response.data.errores.forEach((message) => {
                  setDataToast({
                    active: true,
                    message: message,
                    type: "error",
                  });
                });
              } else {
                setDataToast({
                  active: true,
                  message: err.response.data.errores,
                  type: "error",
                });
              }
            } else {
              setDataToast({
                active: true,
                message: "Ocurrió un error.",
                type: "error",
              });
            }
          });
      } else {
        api
          .editProduct(defaultValues.id, product)
          .then(() => {
            setIsLoading(false);
            setDataToast({
              active: true,
              message: "Producto editado correctamente.",
              type: "success",
            });

            navigate("/producto");
          })
          .catch((err) => {
            setIsLoading(false);
            setSubmitting(false);

            if (err.response.data.errores != undefined) {
              if (Array.isArray(err.response.data.errores)) {
                err.response.data.errores.map((message) => {
                  setDataToast({
                    active: true,
                    message: message,
                    type: "error",
                  });
                });
              } else {
                setDataToast({
                  active: true,
                  message: err.response.data.errores,
                  type: "error",
                });
              }
            } else {
              setDataToast({
                active: true,
                message: "Ocurrió un error.",
                type: "error",
              });
            }
          });
      }
    } else if (!hasServices) {
      setIsLoading(false);
      setSubmitting(false);
      shortError("Debe seleccionar al menos un servicio.");
    } else if (!termsAndConditions) {
      setIsLoading(false);
      setSubmitting(false);
      shortError("Debe cargar un archivo de términos y condiciones.");
    }
  }

  function validate() {
    let response = false;

    if (hasServices && termsAndConditions) response = true;

    return response;
  }

  function arrayEquals(a, b) {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
  }

  function uploadTermsAndConditions(e) {
    let files = e.target.files;
    if (files) {
      setIsLoading(true);

      let data = new FormData();
      let file = files.item(0);
      if (file.type === "application/pdf") {
        data.append("files", files.item(0));

        api
          .uploadFile(data)
          .then((res) => {
            let file = res.data.files[0].url;
            setTermsAndConditions(file);
            setIsLoading(false);
          })
          .catch(() => {
            setIsLoading(false);
            alertMessage("Ocurrió un error al subir el archivo.");
          });
      } else {
        setIsLoading(false);
        alertMessage("Solo se permite un archivo de formato PDF.");
      }
    }
  }

  function allowCorporativeBilling(values) {
    setIsLoading(true);
    api
      .getListNamePaymentMethods(values.companyId, PaymentsMethodAssign.Assigned, PaymentMethodTypes.Cash.Id)
      .then((res) => {
        setPaymenthMethodList(utils.setDataInList(res.data));
      });
    setIsLoading(false);
  }

  function loadpaymentMethods(values) {
    setIsLoading(true);
    api
      .getListNamePaymentMethods(values.companyId, PaymentsMethodAssign.Assigned, PaymentMethodTypes.Cash.Id)
      .then((res) => {
        setPaymenthMethodList(utils.setDataInList(res.data));
      });
    setPaymentMethodData(null);
    setIsLoading(false);
  }

  function alertMessage(text) {
    setDataToast({
      active: true,
      message: text,
      type: "error",
    });
  }

  const loadCategories = (values) => {
    if (values.companyId) {
      api
        .getCategoriesByCompany(values.companyId)
        .then((res) => {
          setCategoriesList(utils.setExtendCategoryDataInList(res.data));
        })
        .then(() => setDisabledCompanies(false));
    } else {
      setDisabledCompanies(true);
    }
    setCategoryData(null);
  };

  useEffect(() => {
    setIsLoading(true);
    api
      .getProduct(id, StatusEnum.Active.Id)
      .then((res) => {
        let data = res.data;
        const companyId = data.companiaId;
        const categoryId = data.categoriaId;
        const paymentMethodId = data.medioPagoId;
        let ids = [];
        data.servicios.forEach((e) => ids.push(e.id));
        const servicesIds = ids;

        if (data?.contratosVinculados?.length > 0 || data?.transaccionVinculada) {
          setVinculatedAgreements(true);
        }

        setHasServices(true);
        setTermsAndConditions(data.rutaPdf);
        let features = data.caracteristicas.map((x) => ({ id: x.id, name: x.nombre })) || [];
        setDefaultValues({
          id: data.id,
          services: servicesIds,
          features,
          name: data.nombre,
          description: data.descripcion,
          period: data.periodo,
          companyId: companyId,
          price: data.precio,
          costCenter: data.centroCosto,
          category: categoryId,
          productType: productTypeList.find((x) => x.key === data.tipo),
          vehicleTypes: (data.tiposVehiculos || []).map(({ id, nombre }) => ({
            key: id,
            text: nombre,
            value: id,
          })),
          pathPdf: data.rutaPdf,
          allowBuyBack: data.permitirRecompra,
          externalProduct: data.productoExterno,
          paymentMethodId: data.medioPagoId,
        });

        Promise.all([
          api.getCompanies().then((res) => {
            res.data = utils.refactorDataInList(res.data, companyId);
            let data = utils.setDataInList(res.data);
            setCompanyData(data[0]);
            setCompaniesList(data);
          }),
          api.getTypesAssistsList().then((res) => {
            let data = utils.setDataInList(res.data);
            let selectedData = data.filter((e) => servicesIds.includes(e.value));
            setTypesAssistsData(selectedData);
            setTypesAssistsList(data);
          }),
          api.getVehicleTypes().then((res) => {
            let data = utils.setDataInList(res.data);
            setVehicleTypes(data);
          }),
          api.getCategoriesByCompany(companyId).then((res) => {
            res.data = utils.refactorDataInList(res.data, categoryId);
            let data = utils.setExtendCategoryDataInList(res.data);
            let categoryExist = utils.searchTextInList(data, categoryId);
            if (categoryExist !== "") {
              setCategoryData(data[0]);
            }
            setCategoriesList(data);
            setDisabledCompanies(false);
          }),
          api
            .getListNamePaymentMethods(companyId, PaymentsMethodAssign.Assigned, PaymentMethodTypes.Cash.Id)
            .then((res) => {
              if (paymentMethodId != null) {
                res.data = utils.refactorDataInList(res.data, paymentMethodId);
                let data = utils.setDataInList(res.data);
                setPaymentMethodData(data[0]);
                setAllowPaymentMethod(true);
                setPaymenthMethodList(data);
              } else {
                setPaymenthMethodList(utils.setDataInList(res.data));
                setAllowPaymentMethod(false);
              }
            }),
        ])
          .then(() => setIsLoading(false))
          .catch((err) => {
            setIsLoading(false);
            setDataToast({
              active: true,
              type: "error",
              message: "Ocurrió un error.",
            });
          });
      })
      .catch((err) => {
        setIsLoading(false);
        setDataToast({
          active: true,
          type: "error",
          message: "Ocurrió un error.",
        });
      });
  }, []);

  return (
    <>
      {defaultValues.id !== undefined && (
        <Paper elevation={3}>
          <Formik initialValues={defaultValues} onSubmit={(values, { setSubmitting }) => save(values, setSubmitting)}>
            {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => (
              <>
                <form className="c-form" onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item md={12}>
                      <h1>PRODUCTO</h1>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <h2>Datos del producto</h2>
                      <Divider />
                      <Grid container spacing={3}>
                        <Grid item md={5} xs={12}>
                          <CustomInputText
                            Name="name"
                            Label="Nombre"
                            Value={values.name || ""}
                            Error={errors.name}
                            Change={handleChange}
                            Blur={handleBlur}
                            disabled={vinculatedAgreements}
                          />
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <Autocomplete
                            options={productTypeList}
                            getOptionLabel={(option) => option.text || ""}
                            onChange={(e, c) => {
                              setFieldValue("productType", c);
                              if (!c) {
                                setFieldValue("vehicleTypes", []);
                              }
                            }}
                            value={values.productType ?? null}
                            inputValue={values.productType ? values.productType.text : ""}
                            disabled={vinculatedAgreements}
                            name="productType"
                            renderInput={(params) => (
                              <TextField {...params} size="small" label="Tipo de Producto" variant="outlined" />
                            )}
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <CustomInputText
                            Name="price"
                            Label="Precio"
                            Type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            Value={values.price || ""}
                            Error={errors.price}
                            Change={handleChange}
                            Blur={handleBlur}
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <CustomInputText
                            Name="period"
                            Label="Período Contrato"
                            Type="number"
                            InputProps={{ inputProps: { min: 30, max: 3000 } }}
                            Value={values.period || ""}
                            Error={errors.period}
                            Change={handleChange}
                            Blur={handleBlur}
                            disabled={vinculatedAgreements}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item md={6} xs={12}>
                          {companyData !== undefined && (
                            <Autocomplete
                              options={companiesList}
                              getOptionLabel={(option) => option.text || ""}
                              onChange={(e, c) => {
                                values.companyId = c ? c.value : undefined;
                                loadCategories(values);
                                allowCorporativeBilling(values);
                                loadpaymentMethods(values);
                                setCompanyData(c);
                              }}
                              value={companyData ?? null}
                              inputValue={companyData ? companyData.text : ""}
                              disabled={vinculatedAgreements}
                              renderInput={(params) => (
                                <TextField {...params} size="small" label="Compañía" variant="outlined" required />
                              )}
                            />
                          )}
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Autocomplete
                            options={categoriesList}
                            getOptionLabel={(option) => option.text || ""}
                            onChange={(e, c) => {
                              setFieldValue("category", c);
                              setCategoryData(c);
                            }}
                            value={categoryData ?? null}
                            inputValue={categoryData ? categoryData.text : ""}
                            disabled={disabledCompanies || vinculatedAgreements}
                            name="category"
                            renderInput={(params) => (
                              <TextField {...params} size="small" label="Categoría" variant="outlined" required />
                            )}
                          />
                        </Grid>
                        <Grid item md={2} xs={12}>
                          <CustomInputText
                            Name="costCenter"
                            Label="Centro de costo"
                            Type="number"
                            InputProps={{ inputProps: { min: 0 } }}
                            Value={values.costCenter || ""}
                            Error={errors.costCenter}
                            Change={handleChange}
                            Blur={handleBlur}
                            disabled={vinculatedAgreements}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item md={12} xs={12}>
                          <FormControl fullWidth={true}>
                            <TextField
                              size="small"
                              variant="outlined"
                              name="description"
                              label="Descripción"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.description || ""}
                              multiline
                              rows={4}
                              rowsMax={4}
                              disabled={vinculatedAgreements}
                              required
                            />
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <h4 style={{ display: "inline-flex" }}>
                            ¿Permitir recomprar producto?
                            <Tooltip
                              title="Activado: El producto podrá tener mas de un contrato vigente hacia un mismo cliente.
                              Desactivado: El producto podrá tener solo un contrato vigente hacia un cliente."
                            >
                              <Info color="primary" />
                            </Tooltip>
                          </h4>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <FormControl fullWidth={true}>
                            <Switch
                              color="primary"
                              defaultChecked={defaultValues.allowBuyBack}
                              value={defaultValues.allowBuyBack}
                              onClick={(e) => {
                                setFieldValue("allowBuyBack", e.target.checked);
                              }}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <TextField
                            fullWidth={true}
                            size="small"
                            variant="outlined"
                            name="externalProduct"
                            label="Producto Externo"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.externalProduct || ""}
                            disabled={vinculatedAgreements}
                            error={errors.externalProduct}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <h4 style={{ display: "inline-flex" }}>
                            ¿Permitir facturar cliente corporativo?
                            <Tooltip
                              title="Activado: El producto tendrá un medio de pago fijo de tipo efectivo.
                                Desactivado: El producto tendra el medio de pago seleccionado en cada contrato."
                            >
                              <Info color="primary" />
                            </Tooltip>
                          </h4>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <FormControl fullWidth={true}>
                            <Switch
                              color="primary"
                              disabled={vinculatedAgreements}
                              defaultChecked={!allowPaymentMethod}
                              onClick={(e) => {
                                setAllowPaymentMethod(e.target.checked);
                                allowCorporativeBilling(values);
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <Autocomplete
                            disabled={vinculatedAgreements}
                            options={paymentMethodList}
                            value={paymentMethodData ?? null}
                            inputValue={paymentMethodData ? paymentMethodData.text : ""}
                            getOptionLabel={(option) => option.text || ""}
                            name="paymentMethodId"
                            onChange={(e, c) => {
                              setFieldValue("paymentMethodId", c ? c : "");
                              setPaymentMethodData(c);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                label="Factura Cliente Corporativo"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                      </Grid>

                      {Boolean(values?.productType && values?.productType?.value === ProductTypesEnum.Vehicular.Id) && (
                        <>
                          <h2>Tipos de Vehículo</h2>
                          <Divider />
                          <Grid container spacing={3}>
                            <Grid item md={12} xs={12}>
                              <MultipleAutocomplete
                                IsMultiple={false}
                                DataList={vehicleTypeList.filter(
                                  ({ key }) => !values.vehicleTypes?.map(({ value }) => value).includes(key)
                                )}
                                SelectedValues={values.vehicleTypes}
                                Label="Tipos de Vehículo"
                                Placeholder="Tipo de vehículo"
                                SetValue={(c) => setFieldValue("vehicleTypes", c)}
                                Disabled={vinculatedAgreements}
                              />
                            </Grid>
                          </Grid>
                        </>
                      )}

                      <h2
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Características
                        {!vinculatedAgreements && (
                          <Tooltip title="Agregar" arrow placement="left">
                            <Button variant="contained" onClick={handleOpen} className="c-ml-5 c-btn-success">
                              <Add />
                            </Button>
                          </Tooltip>
                        )}
                      </h2>
                      <Divider />
                      {Boolean(values?.features?.length) && (
                        <Grid container className="c-grid-results" style={{ padding: 0 }}>
                          <DragDropContext onDragEnd={(e) => handleDragEnd(e, setFieldValue, values.features)}>
                            <Grid item md={12} xs={12}>
                              <TableContainer>
                                <Table className="c-table" size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell style={{ width: "98px" }}></TableCell>
                                      <TableCell style={{ width: vinculatedAgreements ? "1000px" : "900px" }}>
                                        DETALLE
                                      </TableCell>
                                      {!vinculatedAgreements && (
                                        <TableCell style={{ width: "100px" }}>OPCIONES</TableCell>
                                      )}
                                    </TableRow>
                                  </TableHead>
                                  <Droppable droppableId="droppable">
                                    {(droppableProvided) => (
                                      <TableBody
                                        ref={droppableProvided.innerRef}
                                        {...droppableProvided.droppableProps}
                                        style={{ position: "relative", width: "100%" }}
                                      >
                                        {values?.features?.map((item, index) => (
                                          <Draggable
                                            key={item.id.toString()}
                                            draggableId={item.id.toString()}
                                            index={index}
                                          >
                                            {(draggableProvided, snapshot) => (
                                              <TableRow
                                                ref={draggableProvided.innerRef}
                                                {...draggableProvided.draggableProps}
                                                isDragging={snapshot.isDragging}
                                                style={{
                                                  ...draggableProvided.draggableProps.style,
                                                }}
                                                key={index}
                                              >
                                                <TableCell
                                                  style={{ width: "98px" }}
                                                  {...draggableProvided.dragHandleProps}
                                                >
                                                  =
                                                </TableCell>
                                                <TableCell style={{ width: vinculatedAgreements ? "1000px" : "850px" }}>
                                                  {item.name}
                                                </TableCell>
                                                {!vinculatedAgreements && (
                                                  <TableCell style={{ width: "150px" }}>
                                                    <Tooltip title="Eliminar" arrow>
                                                      <IconButton
                                                        className="c-grid-btn-cancel button-grid"
                                                        onClick={() =>
                                                          setFieldValue(
                                                            "features",
                                                            values?.features?.filter((_, i) => i !== index)
                                                          )
                                                        }
                                                      >
                                                        <DeleteIcon />
                                                      </IconButton>
                                                    </Tooltip>
                                                  </TableCell>
                                                )}
                                              </TableRow>
                                            )}
                                          </Draggable>
                                        ))}
                                        {droppableProvided.placeholder}
                                      </TableBody>
                                    )}
                                  </Droppable>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </DragDropContext>
                        </Grid>
                      )}
                      <h2>Servicios</h2>
                      <Divider />
                      <Grid container spacing={3}>
                        <Grid item md={12} xs={12}>
                          {typesAssistsData !== undefined && (
                            <MultipleAutocomplete
                              DataList={typesAssistsList}
                              SelectedValues={typesAssistsData}
                              Label="Selecionar los servicios"
                              Placeholder="Servicio"
                              CheckLength={setHasServices}
                              SetValue={setTypesAssistsData}
                              Disabled={vinculatedAgreements}
                            />
                          )}
                        </Grid>
                      </Grid>

                      <h2>Términos y Condiciones</h2>
                      <Divider />
                      <Grid container spacing={3}>
                        {termsAndConditions && (
                          <Grid item md={12} xs={12}>
                            <Alert severity="success">
                              PDF Subido{" "}
                              <a href={termsAndConditions} target="_blank">
                                aqui.
                              </a>
                            </Alert>
                          </Grid>
                        )}
                        <input
                          className="c-none"
                          id="signature"
                          type="file"
                          accept="application/pdf"
                          onChange={uploadTermsAndConditions}
                        />
                        <Grid item md={12} xs={12}>
                          <label htmlFor="signature">
                            <Button className="c-btn-info c-mb-5" variant="contained" component="span">
                              Subir PDF
                            </Button>
                          </label>
                        </Grid>
                      </Grid>

                      <Grid className="c-mt-25" container spacing={3}>
                        <Grid className="c-text-right" item md={12} xs={12}>
                          <Button variant="contained" onClick={() => navigate("/producto")} className="c-btn-cancel">
                            Cancelar
                          </Button>
                          <Button
                            variant="contained"
                            type="submit"
                            className="c-ml-5 c-btn-success"
                            disabled={isSubmitting}
                          >
                            Guardar
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
                <Dialog
                  open={openNewFeature}
                  onClose={handleClose}
                  PaperProps={{
                    component: "form",
                    onSubmit: (event) => {
                      event.preventDefault();
                      const formData = new FormData(event.currentTarget);
                      const formJson = Object.fromEntries(formData.entries());
                      const maxId = Boolean(values?.features.length)
                        ? Math.max(...values?.features.map((item) => item.id))
                        : 0;
                      const newFeature = { name: formJson.newFeature, id: maxId + 1 };
                      setFieldValue("features", [...values?.features, newFeature]);
                      handleClose();
                    },
                  }}
                >
                  <DialogTitle>
                    <h2>Agregue una nueva característica</h2>
                  </DialogTitle>
                  <DialogContent>
                    <TextField
                      fullWidth
                      required
                      autoFocus
                      margin="dense"
                      name="newFeature"
                      size="small"
                      variant="outlined"
                      label="Detalle"
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button variant="contained" onClick={handleClose}>
                      Cancelar
                    </Button>
                    <Button variant="contained" type="submit" className="c-ml-5 c-btn-success">
                      Agregar
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
          </Formik>
        </Paper>
      )}
    </>
  );
}
